import { LogicOperator, Role } from '@okletsplay/core';
import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { rolesGuard } from 'app/routing/guards';
import { lazyRetry } from 'app/utils';
import { AffiliateProgramConfig } from '../../config/affiliate-program-config';

const AffiliateProgramsAdminPage = lazyRetry(
  () => import('modules/affiliate-programs/pages/AffiliateProgramsAdminPage')
);

const AffiliateProgramsPage = lazyRetry(
  () => import('modules/affiliate-programs/pages/AffiliateProgramsPage')
);

const AffiliateProgramPage = lazyRetry(
  () => import('modules/affiliate-programs/pages/AffiliateProgramPage')
);

const AffiliateProgramAdminPage = lazyRetry(
  () => import('modules/affiliate-programs/pages/AffiliateProgramAdminPage')
);

const Routes: GuardedRoute[] = [
  {
    name: 'Manage Affiliate Programs',
    path: Route.ManageAffiliatePrograms,
    component: AffiliateProgramsAdminPage,
    availability: [Role.User, Role.AffiliateProgramAdmin],
    guards: [rolesGuard([Role.User, Role.AffiliateProgramAdmin])],
  },
  {
    name: 'Manage Affiliate Program Details',
    path: Route.ManageAffiliateProgram,
    component: AffiliateProgramAdminPage,
    availability: [Role.User, Role.AffiliateProgramAdmin],
    guards: [rolesGuard([Role.User, Role.AffiliateProgramAdmin])],
  },
];

if (AffiliateProgramConfig.isAffiliateProgramOwnerViewEnabled()) {
  Routes.push({
    name: 'Affiliate Programs',
    path: Route.AffiliatePrograms,
    component: AffiliateProgramsPage,
    availability: [Role.AffiliateProgramOwner],
    guards: [rolesGuard([Role.AffiliateProgramOwner])],
  });
  Routes.push({
    name: 'Affiliate Program',
    path: Route.AffiliateProgram,
    component: AffiliateProgramPage,
    availability: [Role.AffiliateProgramOwner, Role.AffiliateProgramAdmin],
    guards: [
      rolesGuard([Role.AffiliateProgramAdmin, Role.AffiliateProgramOwner], LogicOperator.OR),
    ],
  });
}

export const AffiliateProgramsRoutes = Routes;
